import { forwardRef } from 'react'
import { upperFirst } from 'es-toolkit'
import { mergeClasses } from 'minimal-shared/utils'

import { labelClasses } from './classes'
import { LabelRoot } from './styles'
import FaIcon from '../shared/faIcon/FaIcon'

// ----------------------------------------------------------------------

export const Label = forwardRef((props, ref) => {
  const {
    endIcon,
    children,
    startIcon,
    className,
    disabled,
    variant = 'soft',
    color = 'default',
    sx,
    ...other
  } = props

  return (
    <LabelRoot
      ref={ref}
      color={color}
      variant={variant}
      disabled={disabled}
      className={mergeClasses([labelClasses.root, className])}
      sx={sx}
      {...other}
    >
      {startIcon && <FaIcon className={labelClasses.icon} icon={startIcon} />}

      {typeof children === 'string' ? upperFirst(children) : children}

      {endIcon && <FaIcon className={labelClasses.icon} icon={endIcon} />}
    </LabelRoot>
  )
})
